import { useSelector } from 'react-redux';
import { selectCompany } from '../../../store/slices/InitialDataSlice';
import { MAX_GIFT_CARD_VALUE, MIN_GIFT_CARD_VALUE, getGiftCardPresets } from '../const';

/**
 * The region's own gift-card bounds and presets, in minor units, falling back to the
 * pre-region defaults when the company's region carries no gift_card limits — every
 * region's limits is empty until the backend's region-command write path populates one.
 */
const useGiftCardLimits = () => {
  const region = useSelector(selectCompany)?.region;
  const min = region?.limits?.gift_card?.min ?? MIN_GIFT_CARD_VALUE * 100;
  const max = region?.limits?.gift_card?.max ?? MAX_GIFT_CARD_VALUE * 100;

  return { min, max, presets: getGiftCardPresets(min, max) };
};

export default useGiftCardLimits;
